export const someFn = () => {
	return 'someFn'
}
